function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isDate, startOfDay } from 'date-fns';
import { isArray } from '@cloud-sn/v-utils';
import DateInput from './date/dateInput.js';
import DateTable from './date/dateTable.js';
import CalendarHeader from './calendar/calendarHeader.js';
import CalendarFooter from './calendar/calendarFooter.js';
export default {
  name: 'MultiCalendar',
  provide: function provide() {
    return {
      multiCalendarRoot: this
    };
  },
  props: {
    prefixCls: {
      type: String,
      default: ''
    },
    locale: {
      type: Object,
      default: undefined
    },
    pickerValue: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    selectedValue: {
      type: [Date, Array],
      default: function _default() {
        return [];
      }
    },
    format: {
      type: String,
      default: ''
    },
    formatSeparator: {
      type: String,
      default: ', '
    },
    placeholder: {
      type: String,
      default: ''
    },
    showDateInput: {
      type: Boolean,
      default: true
    },
    showOk: {
      type: Boolean,
      default: true
    },
    showToday: {
      type: Boolean,
      default: false
    },
    disabledDate: {
      type: Function,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      innerPickerValue: null,
      innerSelectedValue: null,
      innerMode: 'date'
    };
  },
  computed: {
    classes: function classes() {
      var prefixCls = this.prefixCls;
      return _defineProperty({}, prefixCls, true);
    },
    dateFormat: function dateFormat() {
      var format = this.format,
          locale = this.locale;
      return format || locale.dateFormat;
    }
  },
  watch: {
    pickerValue: function pickerValue(nVal) {
      this.setInnerPickerValue(nVal);
    },
    selectedValue: function selectedValue(nVal) {
      this.setInnerSelectedValue(nVal);
    }
  },
  created: function created() {
    var pickerValue = this.pickerValue,
        setInnerPickerValue = this.setInnerPickerValue,
        selectedValue = this.selectedValue,
        setInnerSelectedValue = this.setInnerSelectedValue;
    setInnerPickerValue(pickerValue);
    setInnerSelectedValue(selectedValue);
  },
  methods: {
    setInnerPickerValue: function setInnerPickerValue(value) {
      var innerPickerValue = this.innerPickerValue;
      var val = isDate(value) ? value : innerPickerValue || new Date();
      this.innerPickerValue = val;
    },
    setInnerSelectedValue: function setInnerSelectedValue(value) {
      var val = isArray(value) ? value : [value];
      this.innerSelectedValue = val.filter(function (v) {
        return isDate(v);
      });
    },
    setInnerMode: function setInnerMode(mode) {
      this.innerMode = mode;
    },
    onSelect: function onSelect(value) {
      var innerSelectedValue = this.innerSelectedValue,
          setInnerPickerValue = this.setInnerPickerValue,
          setInnerSelectedValue = this.setInnerSelectedValue;
      var vals = [].concat(_toConsumableArray(innerSelectedValue), [value]);
      setInnerSelectedValue(vals);
      setInnerPickerValue(value);
      this.$emit('select', value, vals);
    },
    onUnSelect: function onUnSelect(value) {
      var innerSelectedValue = this.innerSelectedValue,
          setInnerPickerValue = this.setInnerPickerValue,
          setInnerSelectedValue = this.setInnerSelectedValue;
      var vals = innerSelectedValue.filter(function (v) {
        return startOfDay(v).getTime() !== startOfDay(value).getTime();
      });
      setInnerSelectedValue(vals);
      setInnerPickerValue(value);
      this.$emit('unselect', value, vals);
    },
    onHeaderChange: function onHeaderChange(value) {
      this.setInnerPickerValue(value);
    },
    onPanelChange: function onPanelChange(value, next) {
      var innerPickerValue = this.innerPickerValue,
          setInnerMode = this.setInnerMode;
      setInnerMode(next);
      this.$emit('panel-change', value || innerPickerValue, next);
    },
    onOk: function onOk() {
      var innerSelectedValue = this.innerSelectedValue;
      this.$emit('ok', innerSelectedValue);
    },
    onToday: function onToday() {// const { onSelect } = this;
      // this.$emit('today', value);
      // onSelect(value);
      // TODO: showToday === true
    },
    renderDateInput: function renderDateInput() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          locale = this.locale,
          placeholder = this.placeholder,
          innerSelectedValue = this.innerSelectedValue,
          dateFormat = this.dateFormat;
      return h(DateInput, {
        "props": _objectSpread({}, {
          prefixCls: prefixCls,
          locale: locale,
          placeholder: placeholder,
          value: innerSelectedValue,
          format: dateFormat
        })
      });
    },
    renderCalendarHeader: function renderCalendarHeader() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          locale = this.locale,
          innerMode = this.innerMode,
          innerPickerValue = this.innerPickerValue,
          dateFormat = this.dateFormat,
          onHeaderChange = this.onHeaderChange,
          onPanelChange = this.onPanelChange;
      return h(CalendarHeader, {
        "props": _objectSpread({}, {
          prefixCls: prefixCls,
          locale: locale,
          mode: innerMode,
          value: innerPickerValue,
          format: dateFormat
        }),
        "on": _objectSpread({}, {
          change: onHeaderChange,
          'panel-change': onPanelChange
        })
      });
    },
    renderCalendarBody: function renderCalendarBody() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          innerPickerValue = this.innerPickerValue,
          innerSelectedValue = this.innerSelectedValue,
          dateFormat = this.dateFormat,
          locale = this.locale,
          disabledDate = this.disabledDate,
          onSelect = this.onSelect,
          onUnSelect = this.onUnSelect;
      return h("div", {
        "class": "".concat(prefixCls, "-body")
      }, [h(DateTable, {
        "props": _objectSpread({}, {
          prefixCls: prefixCls,
          value: innerPickerValue,
          selectedValue: innerSelectedValue,
          format: dateFormat,
          locale: locale,
          disabledDate: disabledDate
        }),
        "on": _objectSpread({}, {
          select: onSelect,
          unselect: onUnSelect
        })
      })]);
    },
    renderCalendarFooter: function renderCalendarFooter() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          locale = this.locale,
          innerPickerValue = this.innerPickerValue,
          dateFormat = this.dateFormat,
          showOk = this.showOk,
          showToday = this.showToday,
          disabledDate = this.disabledDate,
          onOk = this.onOk,
          onToday = this.onToday;
      return h(CalendarFooter, {
        "props": _objectSpread({}, {
          prefixCls: prefixCls,
          locale: locale,
          value: innerPickerValue,
          format: dateFormat,
          showOk: showOk,
          isTimePicker: false,
          hasTimePikcer: false,
          showToday: showToday,
          okDisabled: false,
          disabledDate: disabledDate
        }),
        "on": _objectSpread({}, {
          ok: onOk,
          today: onToday
        })
      });
    },
    renderDatePanel: function renderDatePanel() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          renderCalendarHeader = this.renderCalendarHeader,
          renderCalendarBody = this.renderCalendarBody,
          renderCalendarFooter = this.renderCalendarFooter;
      return h("div", {
        "class": "".concat(prefixCls, "-date-panel")
      }, [renderCalendarHeader(), renderCalendarBody(), renderCalendarFooter()]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        classes = this.classes,
        showDateInput = this.showDateInput,
        renderDateInput = this.renderDateInput,
        renderDatePanel = this.renderDatePanel;
    return h("div", {
      "class": classes
    }, [h("div", {
      "class": "".concat(prefixCls, "-panel"),
      "attrs": {
        "role": "panel"
      }
    }, [showDateInput ? renderDateInput() : null, renderDatePanel()])]);
  }
};